import { useState } from "react";
import { useQuery } from "react-query";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { ErrorView } from "common/components/error";
import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import { Placeholder } from "common/components/placeholder";
import { request } from "common/components/request";

import { SESSIONS_UPDATE_FILTERS } from "common/actions/sessions";

import { Paginator } from "common/components/paginator/paginator";

import { SessionFilters } from "./filters";
import { SessionList } from "./sessionList";

import "./sessions.scss";

export const SessionsRedux = function() {
    const [page, setPage] = useState(1);
    const qualifiers_str = useSelector((state) => state.sessions.qualifiers);
    const date_range = useSelector((state) => state.common.date_range, shallowEqual);
    const dispatch = useDispatch();
    
    const qualifiers = new Qualifiers({ value: qualifiers_str });
    const [merchant_ref] = qualifiers.get("merchant_ref");
    const [user_ref] = qualifiers.get("user_ref");
    
    const { data: user } = useQuery(["user", { user_ref }], async() => {
        if (user_ref) {
            const { username } = await request(`/users/${user_ref}`);
            return username;
        }
        return true;
    });
    
    const {
        isIdle, isLoading, isError, isSuccess, data, error
    } = useQuery(["sessions", {
        date_range, qualifiers_str, user_ref, page
    }], () => request("/sessions/", {
        data: {
            q: typeof user === "string" ? `username:${user}` : "",
            start: date_range.startDate,
            end: date_range.endDate,
            limit: 20,
            page
        }
    }), { enabled: !!user });
    
    const updateFiltersHandler = ({ merchant_ref: new_merchant_ref, user_ref: new_user_ref }) => {
        const q = new Qualifiers();
        if (new_merchant_ref) {
            q.add(`merchant_ref:${new_merchant_ref}`);
        }
        
        if (new_user_ref) {
            q.add(`user_ref:${new_user_ref}`);
        }
        
        dispatch(SESSIONS_UPDATE_FILTERS(q));
    };
    
    if (isError) {
        return <ErrorView error={error} />;
    }
    
    if (isLoading || isIdle) {
        return (
            <div>
                <Placeholder size="long"/>
                <Placeholder size="medium"/>
            </div>
        );
    }
    
    if (isSuccess) {
        const {
            limit, count, page: apiStatePage, results = []
        } = data;
        return (
            <div className="sessions-tool">
                <div className="paginator-wrapper top">
                    <SessionFilters
                        merchant_ref={merchant_ref}
                        user_ref={user_ref}
                        updateFiltersHandler={updateFiltersHandler}
                    />
                    <Paginator
                        limit={limit}
                        count={count}
                        page={apiStatePage}
                        next={page * limit < count}
                        results_length={results.length}
                        onPageChange={(new_page) => setPage(new_page)}
                    />
                </div>
                <SessionList data={results} />
                <div className="paginator-wrapper bottom">
                    <Paginator
                        limit={limit}
                        count={count}
                        page={apiStatePage}
                        next={page * limit < count}
                        results_length={results.length}
                        onPageChange={(new_page) => setPage(new_page)}
                    />
                </div>
            </div>
        );
    }
    
    return null;
};
